import Lenis from "lenis";
import gsap, { ScrollTrigger } from "./gsap";

const SCROLL_CONFIG = {
  autoResize: true,
};

class _Scroll extends Lenis {
  #subscribers = [];
  #resizeObserver;

  y = window.scrollY || 0;
  max = window.innerHeight;
  speed = 0;
  percent = 0;

  constructor() {
    super(SCROLL_CONFIG);
    this.#init();
  }

  #init() {
    this.percent = this.y / (document.body.scrollHeight - this.max);

    this.on("scroll", this.#handleScroll);
    gsap.ticker.add((time) => this.raf(time * 1000));

    this.observeHeight((height) => {
      this.resize();
    });
  }

  #handleScroll = ({ scroll, limit, velocity, progress, direction }) => {
    this.y = scroll;
    this.max = limit;
    this.speed = velocity;
    this.percent = progress;

    ScrollTrigger.update();

    this.#subscribers.forEach((subscriber) =>
      subscriber.fn({ scroll, limit, velocity, progress, direction })
    );
  };

  subscribe(fn, priority = 5, id = Symbol()) {
    const subscriber = { fn, id, priority };
    const index = this.#subscribers.findIndex(
      (sub) => sub.priority <= priority
    );

    if (index === -1) {
      this.#subscribers.push(subscriber);
    } else {
      this.#subscribers.splice(index, 0, subscriber);
    }

    return () => this.#unsubscribe(id);
  }

  #unsubscribe(id) {
    this.#subscribers = this.#subscribers.filter(
      (subscriber) => subscriber.id !== id
    );
  }

  toTop() {
    this.scrollTo(0, { immediate: true, force: true });
  }

  observeHeight(callback) {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        callback(entry.target.scrollHeight);
      }
    });

    observer.observe(document.body);
    return () => observer.disconnect();
  }
}

export const Scroll = new _Scroll();

